import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c9d15e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-controls"]
const _hoisted_2 = { class: "row justify-content-between" }
const _hoisted_3 = { class: "col-md" }
const _hoisted_4 = { class: "dokumentnavn" }
const _hoisted_5 = { class: "col-md" }
const _hoisted_6 = {
  key: 0,
  class: "badge badge-small"
}
const _hoisted_7 = {
  key: 1,
  class: "badge badge-small"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = {
  key: 1,
  class: "row"
}
const _hoisted_14 = { class: "col-10" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = {
  key: 2,
  class: "row"
}
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "action-div"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_26 = { class: "action-div" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#playlist-add-check" })
], -1))
const _hoisted_28 = { class: "action-div" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#list-alt" })
], -1))
const _hoisted_30 = { class: "action-div" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_32 = { class: "action-div" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#visibility" })
], -1))
const _hoisted_34 = { class: "action-div" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_36 = {
  key: 0,
  class: "action-div"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_38 = { class: "action-div" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#playlist-add-check" })
], -1))
const _hoisted_40 = { class: "action-div" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#list-alt" })
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#list-alt" })
], -1))
const _hoisted_43 = { class: "action-div" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_45 = { class: "action-div" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#delete" })
], -1))
const _hoisted_47 = { class: "action-div" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#playlist-add-check" })
], -1))
const _hoisted_49 = { class: "action-div" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#list-alt" })
], -1))
const _hoisted_51 = { class: "action-div" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_53 = { class: "action-div" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#visibility" })
], -1))
const _hoisted_55 = { class: "action-div" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_57 = { class: "accordion accordion-unbordered accordion-multiselectable col-8" }
const _hoisted_58 = ["aria-controls"]
const _hoisted_59 = ["id"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_61 = { class: "about-text-box" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "about-text-label" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "about-text-label" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "about-text-label" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "about-text-label" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "about-text-label" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "about-text-label" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("button", {
      class: "accordion-button",
      "aria-expanded": "false",
      "aria-controls": this.label()
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(this.dokument.tender_name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.dokument.display_ended)
            ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.frist-overskredet' }, null, 8, ["tekstNoegle"])
              ]))
            : (_ctx.dokument.originalBlanketId)
              ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.tilbud-er-redigeret' }, null, 8, ["tekstNoegle"])
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_8,
      (_ctx.tab === _ctx.DocumentStatus.PUBLISHED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.produktgruppe' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(this.dokument.product_group_name), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.publiceret' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.publication_date)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.tilbudsfrist' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.end_date)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === _ctx.DocumentStatus.DRAFT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.produktgruppe' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(this.dokument.product_group_name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.startdato' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.start_date)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === _ctx.DocumentStatus.CLOSED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.produktgruppe' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(this.dokument.product_group_name), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.startdato' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.start_date)), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.publiceret' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.publication_date)), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.løber-frem-til' }, null, 8, ["tekstNoegle"]),
              _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.dokument.end_date)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: this.label(),
      "aria-hidden": "true",
      class: "accordion-content"
    }, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", {
          class: "actions col-3",
          style: _normalizeStyle(this.getActionsBoxHeight(_ctx.tab))
        }, [
          _createElementVNode("h5", null, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger' }, null, 8, ["tekstNoegle"])
          ]),
          _hoisted_23,
          (_ctx.tab === _ctx.DocumentStatus.PUBLISHED)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.IsNotOverdue(_ctx.dokument.end_date))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        to: '/blanketTG/' + _ctx.dokument.blanketId + '?og_id=' + _ctx.dokument.og_id + '&product_id=' + _ctx.dokument.nature_code,
                        class: "function-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.rediger-tilbud' }, null, 8, ["tekstNoegle"])
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_router_link, {
                    to: '/blanket/opsummering/' + _ctx.dokument.og_id,
                    class: "function-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.ordregivers-oplysninger' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    to: '/opsummeringTG/' + _ctx.dokument.blanketId,
                    class: "function-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.se-opsummering-af-tilbud' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printOpsummering(_ctx.dokument.blanketId))),
                    class: "function-link"
                  }, [
                    _hoisted_31,
                    _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.kvitteringTG.knap.downloadopsummering" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: '/blanketTG/resultat/' + _ctx.dokument.blanketId,
                    class: "function-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.se-resultat' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printResultat(_ctx.dokument.blanketId))),
                    class: "function-link"
                  }, [
                    _hoisted_35,
                    _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.kvitteringTG.knap.downloadresultat" })
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.tab === _ctx.DocumentStatus.DRAFT)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.dokument.display_ended)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_component_router_link, {
                        to: '/blanketTG/' + _ctx.dokument.blanketId + '?og_id=' + _ctx.dokument.og_id,
                        class: "function-link",
                        id: "overblikTgRediger"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37,
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.rediger-kladde' }, null, 8, ["tekstNoegle"])
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_router_link, {
                    to: '/blanket/opsummering/' + _ctx.dokument.og_id,
                    class: "function-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_39,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.ordregivers-oplysninger' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  (!_ctx.dokument.display_ended && !_ctx.dokument.displayOGEnded)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: '/blanketTG/' + _ctx.dokument.blanketId + '?og_id=' + _ctx.dokument.og_id + '&goto=opsummering',
                        class: "function-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_41,
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.se-opsummering-af-tilbud' }, null, 8, ["tekstNoegle"])
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  (_ctx.dokument.display_ended || _ctx.dokument.displayOGEnded)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: '/opsummeringTG/' + _ctx.dokument.blanketId,
                        class: "function-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42,
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.se-opsummering-af-tilbud' }, null, 8, ["tekstNoegle"])
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printOpsummering(_ctx.dokument.blanketId))),
                    class: "function-link"
                  }, [
                    _hoisted_44,
                    _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.kvitteringTG.knap.downloadopsummering" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: "function-link",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (this.deleteDraft(_ctx.dokument.blanketId)))
                  }, [
                    _hoisted_46,
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.slet-kladde' }, null, 8, ["tekstNoegle"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.tab === _ctx.DocumentStatus.CLOSED)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_router_link, {
                    to: '/blanket/opsummering/' + _ctx.dokument.og_id,
                    class: "function-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_48,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.ordregivers-oplysninger' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_router_link, {
                    to: '/opsummeringTG/' + _ctx.dokument.blanketId,
                    class: "function-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_50,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.se-opsummering-af-tilbud' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.printOpsummering(_ctx.dokument.blanketId))),
                    class: "function-link"
                  }, [
                    _hoisted_52,
                    _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.kvitteringTG.knap.downloadopsummering" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_router_link, {
                    to: '/blanketTG/resultat/' + _ctx.dokument.blanketId,
                    class: "function-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_54,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.handlinger.se-resultat' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printResultat(_ctx.dokument.blanketId))),
                    class: "function-link"
                  }, [
                    _hoisted_56,
                    _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.kvitteringTG.knap.downloadresultat" })
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("ul", _hoisted_57, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "accordion-button about-accordion",
              "aria-expanded": "true",
              "aria-controls": this.label() + '-about'
            }, [
              _createElementVNode("h5", null, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.knap.om-tilbuddet' }, null, 8, ["tekstNoegle"])
              ])
            ], 8, _hoisted_58),
            _createElementVNode("div", {
              id: this.label() + '-about',
              "aria-hidden": "true",
              class: "accordion-content about-accordion"
            }, [
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.beskrivelse-af-udbud' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.tender_description), 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.udbudsnummer' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.tender_number), 1)
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.produktgruppe' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.product_group_name), 1)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.tilbudsfrist' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.date(_ctx.dokument.end_date, 'dd-LL-y kl. HH:mm')), 1)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.antal-produktvarianter-i-tilbud' }, null, 8, ["tekstNoegle"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_ctx.dokument.display_quantity), 1)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.felt.tco-score' }, null, 8, ["tekstNoegle"])
                  ]),
                  (_ctx.dokument.display_lowest_cost)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.dokument.display_lowest_cost) + " kr.", 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.tg-overblik.dokumentvisning.ikke-beregnet' }, null, 8, ["tekstNoegle"])
                      ]))
                ])
              ])
            ], 8, _hoisted_59)
          ])
        ])
      ])
    ], 8, _hoisted_21)
  ]))
}